import { RouteConfig } from 'vue-router';
const List = () => import('./views/list.vue');
const Edit = () => import('./views/edit.vue');
const routers: RouteConfig[] = [
    {
        path: 'list',
        name: 'list',
        component: List
    },
    {
        path: 'edit',
        name: 'edit',
        component: Edit
    },
];
export default routers;

